<!--
 * @Author: 田鑫
 * @Date: 2022-04-21 14:42:34
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-04-24 11:15:44
 * @Description:
-->
<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>统计管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'statisticsSurvey' }">调查问卷统计报表</el-breadcrumb-item>
        <el-breadcrumb-item>调查问卷建议反馈</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form-container box-shadow">
      <el-form class="" label-width="80px" inline>
        <el-form-item label="题号：">
          <el-select v-model="questionId" style="width: 300px" placeholder="请选择具体的问题">
            <el-option v-for="(item, index) in questionList" :key="index" :value="item.id" :label="item.problemName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="loadTableData(questionId)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button @click="exportExcel" type="primary">导出全部</el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="600" border>
        <el-table-column fixed align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="用户联系方式" prop="mobile" width="160px"></el-table-column>

        <el-table-column align="center" label="建议或反馈" prop="reason"></el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import { download } from "../../../../../utils/javascript/download";

export default {
  data() {
    return {
      questionId: "",
      questionList: [],
      pager: {
        pageIndex: 1,
        pageSize: 30,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
    };
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.loadQuestionList();
  },
  // 生命周期 - 方法
  methods: {
    loadQuestionList() {
      this.$http({
        url: global.apiUrl + "/questionnaire/problemList",
        methods: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.questionList = res.body.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    loadTableData(id) {
      this.tableLoading = true;
      const bodyParams = {
        id,
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      };
      this.$http({
        url: global.apiUrl + "/questionnaire/problemProposal",
        methods: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.pager.total = res.body.data.total;
            this.tableData = res.body.data.dataList;
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 导出
     * @param {*}
     * @return {*}
     */
    exportExcel() {
      download(
        "/questionnaire/problemProposalExport",
        {
          id: this.questionId,
        },
        "调查问卷建议反馈"
      );

      // this.$router.open({
      //   path: "/api/web/questionnaire/problemProposalExport",
      //   query: {},
      //   type: "excel",
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-container {
  padding: 20px 20px 10px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
}
</style>
